'use strict';

/* global $ */

import { Ajax } from 'utils/ajax';

function Vote(options) {

    let opt = $.extend(true, {
    }, options);

    function initBlock(el) {
        let $el = $(el);

        console.log('[ Vote/Init ]');

        opt = $.extend({
            value: opt.selector+'__value',
            button: opt.selector+'__btn',
        }, opt);

        let project = $(opt.button).eq(0).data('id');

        if (!$.cookie('prj'+project)) {
            $(opt.button).removeClass('is-disabled');
        } else if ($.cookie('prj'+project) > 0) {
            $(opt.button).eq(0).addClass('is-disabled');
            $(opt.value).addClass('is-active');
        }

        $(opt.button).on('click', function(e) {
            e.preventDefault();
            let project = $(this).data('id');
            console.error($.cookie('prj'+project));
            if ($(this).hasClass('is-disabled')) {
                return;
            } else {
                $.cookie('prj'+project, 1, { expires: 365, path: '/' });
                $(this).addClass('is-disabled');
                $(opt.value).addClass('is-active');
                Ajax.get('set_vote', $(this).data()).then((data) => {
                    if (data.ok) {
                        $(opt.value).html(data.value);
                    } else {
                        console.error('Can\'t change vote');
                    }
                }).catch(function(error) {
                    throw new Error(error);
                });
            }
        });
    }

    $(opt.selector).each(function() {
        initBlock(this);
    });
}

export {
    Vote
};
